'use strict';

var AbstractTableView = require('components/common/views/abstract_table_view');
var App = require('app');
var AppState = require('app_state');
var BatchSelectValuesView = require('components/common/views/batch_select_values_view');
var BatchWriteDialogView = require('components/devices/views/common/batch_write_dialog_view');
var Consts = require('consts');
var DeviceController = require('components/devices/devices_controller');
var FilterTemplate = require('utils/templates/filter');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var Utils = require('components/common/utils');
var Value = require('models/values');

var BaseDeviceListView = AbstractTableView.extend({
    // To implement/define in sub-class (if required):
    // - getTableConfiguration()
    // - getColumnsDialogConfiguration()
    // - getAddDeviceConfiguration()
    // - addDevice(e)
    // - scanDevice(e)

    controller: undefined,
    enableURLHistory: true,

    getCSVFileName: function () {
        return encodeURI('device_list_' + Misc.timestampFormat(new Date()) + '.csv');
    },

    ui: function () {
        var ui = AbstractTableView.prototype.ui();
        ui.add = '.js-tab-btn-add';
        ui.alarm = '.js-tab-btn-alarm';
        ui.config = '.js-tab-btn-config';
        ui.group = '.js-tab-btn-group';
        ui.invite = '.js-tab-btn-invite';
        ui.options = '.js-tab-btn-options';
        ui.scheme = '.js-tab-btn-schema';
        ui.write = '.js-tab-btn-write';
        ui.filterBtn = '.js-tab-btn-filter';
        ui.filterEdit = '.js-edit-filter';
        ui.filterReset = '.js-reset-filter';
        return ui;
    },

    getSelectedModelList: function () {
        return _.map(_.pairs(this.collection.selected), function (pair) {
            return pair[1];
        });
    },

    events: function () {
        return _.extend({}, AbstractTableView.prototype.events, {
            'click @ui.add': 'addDevice',
            'click @ui.alarm': 'setAlarm',
            'click @ui.config': 'batchConfiguration',
            'click @ui.group': 'groupDevices',
            'click @ui.invite': 'invite',
            'click @ui.options': 'configureColumns',
            'click @ui.scheme': 'configureSchemeValues',
            'click @ui.write': 'batchWrite',
            'click @ui.filterBtn': 'showFilter',
            'click @ui.filterEdit': 'showFilter',
            'click @ui.filterReset': 'resetFilter',
        });
    },

    configureSchemeValues: function (e) {
        e.preventDefault();

        var deviceIDs = _.pluck(this.collection.selected, 'id');
        var sidebarConfig = App.request('device:scheme-config', deviceIDs);
        var valueList = App.request('devices:values', deviceIDs);
        var self = this;
        $.when(valueList, sidebarConfig).done(function (valueList, sidebarConfig) {
            if (valueList === undefined || sidebarConfig === false) {
                return;
            }

            self.controller.showSelectValuesDialog({
                deviceID: deviceIDs[0],
                group: '',
                fakeResponse: valueList.getAsResponse(self.deviceCategory),

                AllowedValueTypes: [],
                showUpdateClassInfo: false,
                showUpdateClassDropdown: false,
                useCustomValues: false,
                noValuesMessage: i18n.TR('Es existieren keine gemeinsamen Werte für die ausgewählten Geräte.'),
                values: new Value.Collection(
                    valueList.filter(function (model) {
                        return sidebarConfig.includes(model.get('type') + '_' + model.get('nr'));
                    }),
                    {}
                ),
                update_cb: function (changes, values) {
                    var sidebarConfig = [];
                    _.each(values, function (v) {
                        v.id = v.type + '_' + v.nr;
                        sidebarConfig.push(v.id);
                    });
                    sidebarConfig = _.unique(sidebarConfig);
                    var sidebarConfigRequest = App.request('device:scheme-config', deviceIDs, sidebarConfig);
                    $.when(sidebarConfigRequest).done(function (resp) {
                        if (resp !== false) {
                            Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Wertauswahl wurde gespeichert.'));
                            Backbone.history.loadUrl(Backbone.history.fragment);
                        } else {
                            Notification.show(
                                'error',
                                i18n.TR('Fehler'),
                                i18n.TR('Wertauswahl konnte nicht gespeichert werden.')
                            );
                        }
                    });
                },
            });
        });
    },

    resetFilter: function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.filterObj = {};
        AppState.setURLParameter({ filter: '{}' }, 'update');
        this.gotoPage(1);
        this.refreshTable();
    },

    showFilter: function (e) {
        var self = this;
        e.preventDefault();
        e.stopPropagation();
        this.filterObj = this.filterObj || {};
        this.filterObj.category = [this.deviceCategory];
        this.controller.showFilterDialog(
            this.filterObj,
            function (filter) {
                App.hideModal();
                self.filterObj = filter;
                AppState.setURLParameter({ filter: JSON.stringify(self.filterObj) }, 'update');
                self.gotoPage(1);
                self.refreshTable();
            },
            true
        );
    },

    getColumnsDialogConfiguration: function () {
        var self = this;
        // add generic (device independent) columns
        return {
            category: this.deviceCategory || 'filter',
            columnCategory: this.deviceCategory,
            update_cb: function (columns) {
                AppState.setSelectedColumns(self.deviceCategory || 'filter', columns);
                self.options.columns = AppState.selectedColumns(self.deviceCategory || 'filter');
                self.render();
            },
        };
    },

    addCustomButtons: function (buttons) {},

    getCSVLink: function () {
        return (
            '/api/v1/devices?category=' +
            this.deviceCategory +
            (this.parentDevice && this.parentDevice.id ? '&parent=' + this.parentDevice.id : '') +
            '&filter=' +
            encodeURI(JSON.stringify(this.filterObj || {})) +
            '&format=csv&filename=' +
            this.getCSVFileName()
        );
    },

    getSelectionButtons: function () {
        var buttons = [
            { ButtonText: i18n.TR('Freigeben'), ButtonID: 'invite', ButtonIcon: 'md md-group' },
            { ButtonText: i18n.TR('Labels'), ButtonID: 'group', ButtonIcon: 'fa fa-tags' },
            { ButtonText: i18n.TR('Alarm'), ButtonID: 'alarm', ButtonIcon: 'fa fa-bell-o' },
            {
                ButtonText: i18n.TR('Werte auswählen'),
                ButtonID: 'config',
                ButtonIcon: 'glyphicon glyphicon-cloud-upload',
            },
            { ButtonText: i18n.TR('Wert schreiben'), ButtonID: 'write', ButtonIcon: 'glyphicon glyphicon-pencil' },
            { ButtonText: i18n.TR('Anlagenschema Erweiterung'), ButtonID: 'schema', ButtonIcon: 'fa fa-adjust' },
        ];

        if (this.canDeleteDevice()) {
            buttons.push({ ButtonText: i18n.TR('Löschen'), ButtonID: 'delete', ButtonIcon: 'fa fa-trash' });
        }
        return buttons;
    },

    getTableConfiguration: function () {
        var categoryData = Consts.DeviceCategory[this.deviceCategory];

        var csvURL = this.getCSVLink();
        var config = {
            headerHTML:
                JSON.stringify(this.filterObj || {}) != '{}'
                    ? FilterTemplate({
                          showClear: true,
                          filterText: this.filterObj && AppState.filterToStr(this.filterObj),
                      })
                    : undefined,
            title: categoryData.listTitle,
            columns: AppState.selectedColumns(this.deviceCategory),
            hasRefreshButton: true,
            hasSelectionButtons: true,
            selectionButtons: this.getSelectionButtons(),
            customButtons: [
                { ButtonIcon: 'fa fa-cog', ButtonID: 'options' },
                { ButtonIcon: 'fa fa-filter', ButtonID: 'filter' },
            ],
            CSVLink: csvURL,
            isRedirectToHomeIfEmpty: true,
        };

        if (categoryData.addButtonText && this.canAddDevice()) {
            config.customButtons.unshift({ ButtonText: categoryData.addButtonText, ButtonID: 'add' });
        }

        this.addCustomButtons(config.customButtons);

        return config;
    },

    initialize: function (options) {
        this.controller = options.controller;
        this.parentDevice = options.parentDevice;
        this.listResult = options.listResult;
        this.itemCount = options.itemCount;
        this.addDeviceConfig = options.addDeviceConfig || {};
        this.onUpdateGrouping = options.onUpdateGrouping;
        this.deviceCategory = options.deviceCategory;
        if (!this.deviceCategory && this.deviceCategory !== null) throw 'deviceCategory must be defined in the view.';

        var paramsFromURL = AppState.getURLParameter();
        this.filterObj = paramsFromURL.filter && JSON.parse(paramsFromURL.filter);

        var tableConfig = this.getTableConfiguration();

        tableConfig.itemCount = this.itemCount;
        tableConfig.listResult = this.listResult;
        tableConfig.itemsPerPage = options.itemsPerPage || this.itemsPerPage;
        tableConfig.getSortColumn = this.getSortColumnFunc();
        //		tableConfig.enableCompactMode = true; -- TODO: add support for column name abbreviations

        this.addDeviceConfig = options.addDeviceConfig || {};

        AbstractTableView.prototype.initialize.apply(this, [tableConfig]);
    },

    setPermission: function (permissions) {
        if (permissions.get(Consts.Permissions.AdminDevices)) {
            this.options.selectionButtons = [
                { ButtonText: i18n.TR('Labels'), ButtonID: 'group', ButtonIcon: 'fa fa-tags' },
            ];
            if (AppState.getDeviceInfo(this.parentDevice.id).status !== Consts.DeviceStatus.Archived) {
                this.options.selectionButtons.push({
                    ButtonText: i18n.TR('Alarm'),
                    ButtonID: 'alarm',
                    ButtonIcon: 'fa fa-bell-o',
                });
            }
        }
        this.options.customButtons.push({ ButtonIcon: 'fa fa-cog', ButtonID: 'options' });
    },

    canDeleteDevice: function () {
        return AppState.hasCompanyPermission(Consts.PermissionsCompany.RemoveDevices);
    },

    canAddDevice: function () {
        return AppState.hasCompanyPermission(Consts.PermissionsCompany.AddDevices);
    },

    serializeData: function () {
        return AbstractTableView.prototype.serializeData.apply(this, arguments);
    },

    groupDevices: function (e) {
        e.preventDefault();

        var selectedDevices = [];
        _.each(_.values(this.collection.selected), function (element) {
            selectedDevices.push(element);
        });

        var self = this;
        this.controller.showGroupingDialog({
            models: selectedDevices,
            update_cb: function () {
                self.render();
                if (self.onUpdateGrouping) {
                    self.onUpdateGrouping();
                }
            },
        });
    },

    setAlarm: function (e) {
        e.preventDefault();
        this.controller.createAlarm(this.getSelectedModelList());
    },

    configureColumns: function (e) {
        e.preventDefault();
        var self = this;

        AppState.requireColumns(function () {
            Utils.showConfigureColumnsDialog(self.getColumnsDialogConfiguration());
        });
    },

    getSortColumnFunc: function (moreCols) {
        var result = function (c) {
            var id = c.id;

            if (id.startsWith('#_')) {
                id = id.substring(2, id.length);
            }

            var sortColMap = { groups: '' };

            var id2 = sortColMap[id];
            if (id2 !== undefined && id2 == '') {
                return undefined;
            }

            return id2 || id;
        };

        return result;
    },

    getAddDeviceConfiguration: function () {
        // default implementation: read from controller
        return this.controller.getAddDeviceConfiguration();
    },

    invite: function (e) {
        e.preventDefault();
        var selectedList = [];
        _.each(this.collection.selected, function (item) {
            selectedList.push(item);
        });
        this.controller.invite(selectedList);
    },

    updateSelectionButtons: function () {
        var self = this;
        self.ui.invite.removeClass('disabled');
        AbstractTableView.prototype.updateSelectionButtons.apply(this);
        // deactivate "invite" when an item without "can_share" selected
        if (
            Misc.selectWhereFirst(this.collection.selected, function (item) {
                return !item.get('can_config');
            })
        ) {
            self.ui.config.addClass('disabled');
            self.ui.scheme.addClass('disabled');
        }
        if (
            Misc.selectWhereFirst(this.collection.selected, function (item) {
                return !item.get('can_share');
            })
        ) {
            self.ui.invite.addClass('disabled');
        }
        if (
            Misc.selectWhereFirst(this.collection.selected, function (item) {
                return !item.get('can_write');
            })
        ) {
            self.ui.write.addClass('disabled');
        }
    },

    addDevice: function (e) {
        e.preventDefault();
        var categoryCfg = Consts.DeviceCategory[this.deviceCategory] || 'filter';
        if (categoryCfg.addTrigger) App.trigger(categoryCfg.addTrigger);
        else DeviceController.addDevice(this.getAddDeviceConfiguration());
    },

    batchWrite: function (e) {
        e.preventDefault();
        App.showModal(
            new BatchWriteDialogView({
                controller: this.controller,
                collection: this.collection,
            })
        );
    },

    batchConfiguration: function (e) {
        e.preventDefault();
        App.showModal(
            new BatchSelectValuesView({
                controller: this.controller,
                collection: this.collection,
            })
        );
    },

    modelAction: function (e, deviceID) {
        Misc.modelAction(e, deviceID, App, AppState, this.collection);
    },
});

module.exports = BaseDeviceListView;
